import {
    defineStore,
} from 'pinia';
import {
    computed, reactive, toRefs,
} from 'vue';
import {
    createSkill, DEFAULT_LEVEL_ID, skillLevelById,
} from '../models/Skill';
import {
    createAdaptedOption,
} from '../utils/AdaptedOption';

export const DEFAULT_ROW = {
    id: null,
    label: '',
    level: {},
};
const DEFAULT_SKILL = { ...DEFAULT_ROW, level: skillLevelById(DEFAULT_LEVEL_ID) };

export const useSkillStore = defineStore('profile-skills', () => {
    const state = reactive({
        skills: [],
    });

    function resetState() {
        Object.keys(state.skills).forEach((key) => {
            state[key] = DEFAULT_ROW[key];
        });
    }

    function update(value) {
        state.skills = value.map((skill) => {
            const existingSkill = state.skills.find(({ id }) => id === skill.id);
            return { ...DEFAULT_SKILL, ...existingSkill, ...skill };
        });
        return state.skills;
    }

    function updateFromQuery(data) {
        // The default row is merged to make sure all necessary fields are initialized.
        // eslint-disable-next-line no-param-reassign
        state.skills = data.map(skill => ({
            ...DEFAULT_ROW,
            id: skill.id,
            label: skill.name,
            level: skill.level ? {
                id: skill.level,
                label: skill.levelLabel,
            } : {},
        }));
    }

    function updateLevel({ label, levelId }) {
        // eslint-disable-next-line no-param-reassign
        state.skills.find(skill => skill.label === label).level = skillLevelById(levelId);
    }

    const count = computed(() => state.skills.length);
    const filled = computed(() => state.skills.length > 0);
    const models = computed(() => state.skills.map(x => createSkill(x)));

    return {
        ...toRefs(state),
        count,
        filled,
        models,
        resetState,
        update,
        updateLevel,
        updateFromQuery,
    };
});

export function labelDefinitionAdapter(skill) {
    return skill.level.label;
}

export function optionAdapter(skill) {
    return createAdaptedOption({
        id: skill.id,
        label: skill.label,
        value: skill,
    });
}

export function skillValueAdapter(label) {
    return { ...DEFAULT_SKILL, label };
}
